import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon, List, Pagination } from 'semantic-ui-react';
import DeleteConfirmation from '../../../app/common/modals/DeleteConfirmation';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { useStore } from '../../../app/stores/store';
import LinkExisiting from './LinkExisiting';
import SectionsModal from './SectionsModal';
import SectionsModalMultiple from './SectionsModalMultiple';
import ReelsCreationNFAI from './ReelsCreationNFAI';
import CutListCreationNFAI from './CutListCreation';
import AVSyncUploadNfai from '../Sections/Nfai_AV_SyncUpload/index';
// import NFHMpictureqc from './NFHMpictureqc';


function SectionsMain() {
  const {
    activityStore,
    clonedStore,
    mediaAssetStore,
    modalStore,
    commonStore,
    reportStore,
    userStore,
    viewStore: { itemDetails },
  } = useStore();
  const [redirect, setRedirect] = useState(true);
  const { selectedActivity } = activityStore;
  const history = useNavigate();
  const { LinkExsitingArray } = reportStore;

  const {
    loadComponentById,
    loadSectionById,
    sectionClonedItems,
    loadSectionMultipleById,
    loadingInitial,
  } = clonedStore;

  const [posts, setPosts] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(15);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts?.slice(indexOfFirstPost, indexOfLastPost);
  const isNFAIReportCustomer = userStore?.user?.customerName === 'NFAIReport';
  const isFilmType = itemDetails.type === 'Film';

  const paginate = (event:SyntheticEvent, data:any) => {
    setCurrentPage(data.activePage);
};
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    mediaAssetStore.setOpenSectionsExiste(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
    // eslint-disable-next-line
  }, [posts]);
  useEffect(() => {
    loadComponentById(selectedActivity?.id);
    loadSectionById(
      userStore.user?.customerName === 'NFAIReport'
      ? activityStore.selectedActivity?.id :
      activityStore.selectedActivity?.id +
        '/' +
        activityStore.selectedActivity?.title,
    );
    loadSectionMultipleById(
      activityStore.selectedActivity?.id +
        '/' +
        activityStore.selectedActivity?.title,
    ); // eslint-disable-next-line
  }, [selectedActivity?.id, mediaAssetStore.mediaAsset.refreshSectionMain]);

  useEffect(() => {
    if (sectionClonedItems) {
      setPosts(sectionClonedItems);
    }
    // eslint-disable-next-line
  }, [sectionClonedItems]);

  const clonedroute = (a: any) => {
    if (redirect) {
      history(`/mediaAssets/${a?.id}`);
      // window.location.reload();
    }
  };

  const deleteData = (
    data: any,
    Parent: string | null,
    existing: string | null,
  ) => {
    if (Parent !== null && selectedActivity?.id === Parent?.split('/')[0]) {
      modalStore.openModal(
        <DeleteConfirmation type={'Parent'} name={data.title} data={data} />,
      );
    } else if (existing !== null && selectedActivity?.id === existing) {
      modalStore.openModal(
        <DeleteConfirmation type={'Existing'} name={data.title} data={data} />,
      );
    }
  };
  return (
    <div style={{ padding: '10px' }}>
      {mediaAssetStore.mediaAsset.openSectionSingle && (
        <SectionsModal title="sectionSingle" />
      )}
      {mediaAssetStore.mediaAsset.openSectionMultiple && (
        <SectionsModalMultiple />
      )}
      {mediaAssetStore.mediaAsset.openSectionExiste && <LinkExisiting />}
      <div>
        <Button
          primary
          onClick={() => mediaAssetStore.setOpenSectionsSingle(true)}
          //Create Single
        >
          {
            (
              userLanguage[0]
                .AssetsViewItemLevelViewPageAssetsSegmentPhysicalTab
                .AVILVPASPTPB01 as any
            )?.[`${commonStore.language.key}`]
          }
        </Button>
        <Button
          secondary
          onClick={() => mediaAssetStore.setOpenSectionsMultiple(true)}
          //Create Multiple
        >
          {userStore.user?.customerName === 'Restoration'
            ? 'Import Cutlist'
            : (
                userLanguage[0]
                  .AssetsViewItemLevelViewPageAssetsSegmentPhysicalTab
                  .AVILVPASPTPB02 as any
              )?.[`${commonStore.language.key}`]}
        </Button>
        {
          <Button
            primary
            onClick={() => {
              LinkExsitingArray.length = 0;
              //how to clear string array in react typescript?

              mediaAssetStore.setOpenSectionsExiste(true);
            }}
            //Link Existing
            className="link-existing-btn"
          >
            {
              (
                userLanguage[0]
                  .AssetsViewItemLevelViewPageAssetsSegmentPhysicalTab
                  .AVILVPASPTPB03 as any
              )?.[`${commonStore.language.key}`]
            }
          </Button>
        }
      </div>
      <div>
        {isNFAIReportCustomer && isFilmType && <ReelsCreationNFAI />}
        {isNFAIReportCustomer && isFilmType && <AVSyncUploadNfai />}
        {/* {isNFAIReportCustomer && isFilmType &&  <NFHMpictureqc />} */}
        {isNFAIReportCustomer &&
          itemDetails.type === 'Reel' &&
          itemDetails.parent !== null &&
          itemDetails.element !== 'Cutlist' && <CutListCreationNFAI />}
      </div>
      <List divided relaxed>
        {posts.length > 0 ? (
          posts &&
          currentPosts.map((a: any) => (
            <>
              <List.Item
                key={a.id}
                style={{ padding: '8px', cursor: 'pointer' }}
                onClick={() => clonedroute(a)}
              >
                <List.Content>
                  {loading || loadingInitial ? (
                    <LoadingComponent />
                  ) : (
                    <List.Header as="a">
                      {' '}
                      {a.title}{' '}
                      <Icon
                        name="window close outline"
                        color="black"
                        onMouseEnter={() => setRedirect(false)}
                        onMouseLeave={() => setRedirect(true)}
                        onClick={() => deleteData(a, a.parent, a.existing)}
                      />
                    </List.Header>
                  )}
                </List.Content>
              </List.Item>
            </>
          ))
        ) : (
          <p
            style={{
              marginTop: '20%',
              padding: 'auto',
              color: 'black',
              textAlign: 'center',
            }}
            //No Sections Found
          >
            {
              (
                userLanguage[0]
                  .AssetsViewItemLevelViewPageAssetsSegmentPhysicalTab
                  .AVILVPASPTPL01 as any
              )?.[`${commonStore.language.key}`]
            }
          </p>
        )}
      </List>
      {posts && currentPosts?.length > 0 ? (
       <Pagination
       pointing
       secondary
       activePage={currentPage}
       totalPages={Math.ceil(posts.length / postsPerPage)}
       onPageChange={paginate}
   />   
      ) : null}
    </div>
  );
}

export default observer(SectionsMain);
